// extracted by mini-css-extract-plugin
export default {"ButtonPlaceholder":"mEhU_0db","ButtonSkeleton":"hrwze3II","IconPlaceholder":"XCuc8r90","Phonebox":"P4kDEsu0","PhoneboxPlaceholder":"Fr3LQaxt"};